export default {
    SET_RESPONSE(state, val) {
        state.isResponse.code = val;
    },
}